import { Banner, mapToPageHeader } from '@components/Banner';
import { mapToSEO } from '@components/SEO';
import {
  SignupBannerWrapper,
  mapToKiwiVIPVisible,
} from '@components/SignupBanner';
import {
  mapToImageLinkBanner,
  ImageButtonBanner,
} from '@components/ImageButtonBanner';
import { mapToPlateHoleGuidePlates } from '@mappers/ProductModels/mapper';
import SEO from '~/components/SEO/SEO';
import { data, LoaderFunction } from '@remix-run/node';
import { queryItemByCodeName } from '~/utils/kontentClientWrapper';
import { useLoaderData } from '@remix-run/react';
import { PlateSizeGuidePage } from '~/_models';
import PlateHoleGuide from '~/components/PlateHoleGuide/PlateHoleGuide';
export { headers } from '~/defaults.server';
export const loader: LoaderFunction = async ({ request }) => {
  const plateSizeGuidePageData = await queryItemByCodeName<PlateSizeGuidePage>(
    'plate_hole_guide_page',
  );

  return data<PlateSizeGuidePage>(plateSizeGuidePageData, {
    headers: {
      'Cache-Control': `public, max-age=${process.env.HTTP_CACHE_MAX_AGE || 300}, stale-while-revalidate=${process.env.STALE_WHILE_REVALIDATE || 3600}`,
    },
  });
};

const PlateHoleGuidePage = () => {
  const { elements, system } = useLoaderData<PlateSizeGuidePage>();

  const seo = mapToSEO(elements);
  const kiwiVip = mapToKiwiVIPVisible(elements);
  const metadata = mapToPageHeader(elements);
  const imageLink = mapToImageLinkBanner(
    elements.imageLinkBanner.linkedItems[0]?.elements,
  );
  const holeGuidePlates = mapToPlateHoleGuidePlates(
    elements.plates.linkedItems,
  );

  return (
    <>
      <SEO {...seo} />
      <Banner {...metadata} isBiggerBanner={false} />
      <PlateHoleGuide
        plates={holeGuidePlates}
        heading={elements.heading.value}
      />
      {imageLink && <ImageButtonBanner {...imageLink} />}
      {kiwiVip.visible && <SignupBannerWrapper version={kiwiVip.version} />}
    </>
  );
};

export default PlateHoleGuidePage;
